import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ClipboardList } from "lucide-react";
import { http } from "../lib/api";
import { StageChip } from "../lib/stages";
import { EmptyState, Skeleton } from "../components/kit/AIProgress";

export default function Faltantes() {
  const [rows, setRows] = useState(null);
  useEffect(() => { http.get("/faltantes").then((r) => setRows(r.data)); }, []);
  return (
    <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-10" data-testid="faltantes-page" style={{ animation: "rise .35s ease-out both" }}>
      <p className="text-xs font-semibold uppercase tracking-widest text-[#8C867A]">Checklist por deal</p>
      <h1 className="font-serif-display mt-1 text-4xl font-bold sm:text-5xl">Lo que falta<span className="text-[#E8643C]">.</span></h1>
      <div className="mt-8 grid gap-4 md:grid-cols-2">
        {!rows && [0, 1].map((i) => <Skeleton key={i} className="h-56 w-full" />)}
        {rows?.length === 0 && <div className="md:col-span-2"><EmptyState icon={ClipboardList} title="Nada pendiente" text="Tus deals tienen la documentación completa." testid="faltantes-empty" /></div>}
        {rows?.map((d, i) => {
          const pct = Math.round((100 * (d.items.length - d.faltan)) / d.items.length);
          return (
            <Link key={d.id} to={`/deals/${d.id}?tab=documentos`} data-testid={`faltantes-deal-${d.id}`} style={{ animation: `rise .3s ease-out ${i * 60}ms both` }}
              className="rounded-3xl border border-[#E2DDD5] bg-white p-5 transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-md">
              <div className="flex items-start justify-between gap-3"><div className="min-w-0"><p className="truncate font-semibold">{d.nombre}</p>
                <p className="text-xs text-[#8C867A]">{d.tipo === "PFAE" ? "Persona física" : "Persona moral"} · {d.owner_name}</p></div><StageChip stage={d.stage} /></div>
              <div className="mt-3 flex items-center gap-3"><div className="h-2 flex-1 overflow-hidden rounded-full bg-[#F2F0EC]"><div className="h-full rounded-full bg-[#E8643C] transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
                <span className="text-sm font-bold tabular-nums" data-testid={`faltantes-pct-${d.id}`}>{pct}%</span></div>
              <ul className="mt-4 space-y-1.5">{d.items.map((it) => (
                <li key={it.key} className="flex items-center gap-2 text-sm" data-testid={`faltantes-item-${d.id}-${it.key}`}>
                  {it.ok ? <CheckCircle2 size={15} className="text-emerald-600" /> : <Circle size={15} className="text-[#C9C3B8]" />}
                  <span className={it.ok ? "text-[#8C867A]" : "font-medium"}>{it.label}</span></li>))}</ul>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
